import React from 'react';
import cn from 'classnames';
import moment from 'moment';
import { wpToCF } from '../../utils/data/cdn';
import styles from './styles.module.css';

interface Props {
  title: string;
  image?: string;
  publishDate?: Date;
}

const ArticleHero = ({ title, image, publishDate }: Props) => {
  const style = {
    backgroundImage: `url(${wpToCF(image)})`
  };

  return (
    <div className='relative'>
      <div
        className={cn(
          styles.hero,
          'bg-cover bg-center w-full sm:w-3/4 md:w-1/2 flex flex-col md:flex-row'
        )}
        style={image ? style : undefined}
      >
        <div className={`w-1/2 hidden md:block absolute  p-4 ${styles.header}`}>
          <h1 className='block w-full font-sans text-3xl font-bold text-abn-brown'>
            {title}
          </h1>
          {publishDate && (
            <span className='inline-block pt-2 font-sans text-gray-600'>
              {moment(publishDate).format('Do MMMM yyyy')}
            </span>
          )}
        </div>
      </div>
      <div className={`py-4 block md:hidden`}>
        <h1 className='block w-full font-sans text-2xl font-bold text-abn-brown'>
          {title}
        </h1>
        {publishDate && (
          <span className='inline-block pt-2 font-sans text-gray-600'>
            {moment(publishDate).format('Do MMMM yyyy')}
          </span>
        )}
      </div>
    </div>
  );
};

export default ArticleHero;
